export default class UpwardCurve {
  constructor(source, target) {
    this.source = source
    this.target = target
  }

  toSVGCommand = () => {
    const source = this.source
    const target = this.target

    return `
      M ${source.x},${source.y}
      C ${source.x},${source.y}
        ${target.x},${source.y}
        ${target.x},${target.y}
    `
  }
}
